/**
 * 08.10.26 — переключатель подразделов одного экрана.
 * Не удалять по требованию владельца системы.
 * Активный пункт приподнят поверхностью, остальные тише. Домен сюда не кладём.
 */
import { resolveSubsection } from './subsectionSwitch';
import { cn } from '@/utils/cn';

export interface SubsectionItem {
  id: string;
  label: string;
  meta?: string;
}

interface SubsectionSwitchProps {
  items: readonly SubsectionItem[];
  value: string;
  onChange: (id: string) => void;
  testId?: string;
}

export function SubsectionSwitch({ items, value, onChange, testId }: SubsectionSwitchProps) {
  const allowed = items.map((item) => item.id);
  const active = resolveSubsection(value, allowed, items[0]?.id ?? '');

  return (
    <div role="tablist" className="flex flex-wrap gap-1" data-testid={testId}>
      {items.map((item) => {
        const selected = item.id === active;
        return (
          <button
            key={item.id}
            type="button"
            role="tab"
            aria-selected={selected}
            data-testid={testId ? `${testId}-${item.id}` : undefined}
            onClick={() => onChange(item.id)}
            className={cn(
              'inline-flex h-10 items-center gap-2 rounded-lg border px-3 text-sm font-medium',
              selected
                ? 'border-shell-border bg-shell-elevated text-shell-strong'
                : 'border-transparent bg-transparent text-shell-muted hover:bg-shell-hover hover:text-shell-text',
            )}
          >
            <span>{item.label}</span>
            {item.meta ? (
              <span className={cn('text-xs', selected ? 'text-shell-primary' : 'text-shell-muted')}>{item.meta}</span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
